module.exports = __webpack_public_path__ + "static/img/logo.a5ba852.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 7Otq
// module chunks = 12